import styled from "styled-components";

const MyDiv = styled.div`
  .upload_wrapper {
    max-width: 400px;
    margin: auto;
    background: white;
    padding: 0px 10px 10px 10px;
    
  }

  .upload-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .drop-box {
    border: 1px dashed #ccc;
    padding: 30px;
    width: 100%;
    text-align: center;
    border-radius: 10px;
    background:white;
  }

  .Samplebtn {
  border: 1px #0B54A04D solid;
  padding:5px;
  margin-top:20px;
  background-color:white;
  color:#1E87F0;
  }
`;

export default MyDiv;
